import jStat from 'jstat';

export interface MeanAbsoluteDeviationResult {
  population: {
    meanDeviation: number;
  };
  sample: {
    meanDeviation: number;
  };
  mean: number;
  data: number[];
  interpretation: string;
}

export function calculateMeanAbsoluteDeviation(data: number[]): MeanAbsoluteDeviationResult {
  const sortedData = [...data].sort((a, b) => a - b);
  const mean = jStat.mean(data);
  
  // Calculate mean absolute deviation
  const popMeanDev = data.reduce((sum, val) => sum + Math.abs(val - mean), 0) / data.length;
  const sampleMeanDev = data.reduce((sum, val) => sum + Math.abs(val - mean), 0) / (data.length - 1);
  
  return {
    population: {
      meanDeviation: popMeanDev
    },
    sample: {
      meanDeviation: sampleMeanDev
    },
    mean,
    data: sortedData,
    interpretation: `The mean absolute deviation from ${mean.toFixed(2)} is ${popMeanDev.toFixed(2)} (population) and ${sampleMeanDev.toFixed(2)} (sample). This indicates the average distance of values from the mean.`
  };
} 